var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import IconButton from "@mui/material/IconButton";
import { hideSnack, showSnack } from "../../TSnackbar";
import DeleteIcon from "@mui/icons-material/Delete";
import { Grid } from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { TableContext } from "../TableProvider";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DeleteButton(props) {
    var _this = this;
    var ctx = useContext(TableContext);
    var onRemove = props.onRemove;
    var callback = useCallback(function () { return __awaiter(_this, void 0, void 0, function () { var key, e_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                key = showSnack("Removing...");
                setShowConfirm(false);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, onRemove()];
            case 2:
                _a.sent();
                ctx.reload();
                hideSnack(key);
                showSnack("Removed items", { variant: "success" });
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                hideSnack(key);
                showSnack(e_1.message, { variant: "error" });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    }); }); }, [onRemove, ctx]);
    var _a = useState(false), showConfirm = _a[0], setShowConfirm = _a[1];
    return /*#__PURE__*/ _jsxs(Grid, { children: [/*#__PURE__*/ _jsxs(Dialog, { open: showConfirm, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "Confirmation" }), /*#__PURE__*/ _jsx(DialogContent, { children: /*#__PURE__*/ _jsx(DialogContentText, { children: "Are you sure you want to archive these items?" }) }), /*#__PURE__*/ _jsxs(DialogActions, { children: [/*#__PURE__*/ _jsx(Button, { onClick: function () { return setShowConfirm(false); }, children: "Cancel" }), /*#__PURE__*/ _jsx(Button, { color: "primary", onClick: callback, children: "Archive Items" })] })] }), /*#__PURE__*/ _jsx(IconButton, { disabled: props.disabled, size: "small", onClick: function () { return setShowConfirm(true); }, children: /*#__PURE__*/ _jsx(DeleteIcon, {}) })] });
}
